import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import { FileOutlineIcon } from '@twistopayments/design-system/icons/inline'

import type {
  ArticleFileComponent,
  SectionsFileListComponent,
} from '@twisto/api-cms'

import { getStrapiMedia } from 'homepage/utils'

import * as styles from './file-list.styles'

export const File = ({ name, document }: ArticleFileComponent) => {
  const url = getStrapiMedia(document?.url)

  const fileDetails = `(${document?.ext}, ${document?.size?.toFixed()}kB)`

  return (
    <div css={styles.file}>
      <FileOutlineIcon size="24" />
      <a css={styles.link} href={url} rel="noopener noreferrer" target="_blank">
        <span css={styles.name}>{name}</span>{' '}
        <span css={styles.details}>{fileDetails}</span>
      </a>
    </div>
  )
}

export const FileList = ({ files, headline }: SectionsFileListComponent) => (
  <section css={styles.section}>
    {headline && (
      <Typography css={styles.title} fontWeight="heavy" variant="h1">
        {headline}
      </Typography>
    )}

    <ul css={styles.list}>
      {files?.map((file) => <File key={file.id} {...file} />)}
    </ul>
  </section>
)
